var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIconFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.75 26.8929C20.25 22.2643 24.75 18.1197 24.75 13.0071C24.75 7.89456 20.7206 3.75 15.75 3.75C10.7794 3.75 6.75 7.89456 6.75 13.0071C6.75 18.1197 11.25 22.2643 15.75 26.8929Z",
    stroke: "white",
    strokeOpacity: 0.85,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIconFooter);
export default __webpack_public_path__ + "static/media/location_icon-footer.ab8f51a2d9fb5f747751f69094e792a3.svg";
export { ForwardRef as ReactComponent };